import React from 'react';

import { UseFormWatch } from 'react-hook-form';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/AssociatedDocuments/components/LinksView/mobile/LinksView.mobile.module.scss';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal.types';

type ExternalDocument = IFields['externalDocuments'][0];
type ExternalDocumentLink = IFields['externalLinks'][0];

interface Props {
    watch: UseFormWatch<IFields>;
    handleDeleteAssociatedDocumentsLinks: (index: number) => void;
    handleDeleteAssociatedDocuments: (id: number) => void;
    handleDownloadExternalDocument: (documentId: number, fileName: string) => void;
}

export const LinksViewMobile = ({
    watch,
    handleDeleteAssociatedDocumentsLinks,
    handleDeleteAssociatedDocuments,
    handleDownloadExternalDocument,
}: Props) => {
    return (
        <div className={classes.linksView}>
            <ul id={'cardModalExternalLinks'}>
                {watch('externalLinks').map((item: ExternalDocumentLink, index: number) => (
                    <li key={item.title}>
                        <div className={classes.LinkWrapper}>
                            <MuiIcon icon={'link'} fontSize={'3rem'} />
                            <a href={item.url} target={'_blank'}>
                                {item.title}
                            </a>
                        </div>
                        <span
                            onClick={() => {
                                handleDeleteAssociatedDocumentsLinks(index);
                            }}
                        >
                            <Icon name={'filter-x-icon'} size={'22'} color={'red'} />
                        </span>
                    </li>
                ))}
            </ul>
            <ul id={'cardModalExternalDocuments'}>
                {watch('externalDocuments')
                    .filter((document: ExternalDocument) => document.delete === undefined)
                    .map((document: ExternalDocument) => {
                        return (
                            <li key={document?.id}>
                                <div className={classes.LinkWrapper}>
                                    <MuiIcon icon={'article'} fontSize={'3rem'} />
                                    <div
                                        onClick={() => {
                                            handleDownloadExternalDocument(document.id, document.name);
                                        }}
                                        className={classes.documentLink}
                                    >
                                        {document.name}
                                    </div>
                                </div>
                                <span
                                    onClick={() => {
                                        handleDeleteAssociatedDocuments(document.id);
                                    }}
                                >
                                    <Icon name={'filter-x-icon'} size={'22'} color={'red'} />
                                </span>
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
};
